'use strict';

document.addEventListener('DOMContentLoaded', function ()
{
	document.querySelectorAll('a[href^="mailto:"]').forEach(email => {
    email.href = email.href
      .replace('chocolate', 'customer-service');
    if (email.textContent) {
      email.textContent = email.textContent
        .replace('chocolate', 'customer-service');
    }
  });
});